import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DashboardLayout from "../../layouts/DashboardLayout";

import {
  getWorkoutPlan,
  updateWorkoutPlan,
} from "../../services/workoutPlanService";

import "./WorkoutPlans.css";

export default function EditWorkoutPlan() {
  const navigate = useNavigate();

  const { id } = useParams();

  const [formData, setFormData] = useState({
    planName: "",
    goal: "",
    level: "",

    monday: "",
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
    saturday: "",
    sunday: "",
  });

  useEffect(() => {
    loadPlan();
  }, []);

  const loadPlan = async () => {
    try {
      const data = await getWorkoutPlan(id);

      if (data) {
        setFormData(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async () => {
    try {
      await updateWorkoutPlan(id, formData);

      alert("Workout Plan Updated Successfully");

      navigate("/workout-plans");
    } catch (error) {
      console.error(error);

      alert("Failed to Update Workout Plan");
    }
  };

  return (
    <DashboardLayout>
      <div className="workout-container">
        <div className="workout-header">
          <div>
            <h1>Edit Workout Plan</h1>

            <p>Update your workout schedule.</p>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-grid">
            <div className="form-group">
              <label>Plan Name</label>

              <input
                type="text"
                name="planName"
                value={formData.planName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Goal</label>

              <select name="goal" value={formData.goal} onChange={handleChange}>
                <option value="">Select Goal</option>

                <option>Fat Loss</option>

                <option>Weight Gain</option>

                <option>Muscle Gain</option>

                <option>Strength</option>

                <option>General Fitness</option>
              </select>
            </div>

            <div className="form-group">
              <label>Level</label>

              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
              >
                <option value="">Select Level</option>

                <option>Beginner</option>

                <option>Intermediate</option>

                <option>Advanced</option>
              </select>
            </div>

            <div className="form-group">
              <label>Monday</label>

              <input
                type="text"
                name="monday"
                value={formData.monday}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Tuesday</label>

              <input
                type="text"
                name="tuesday"
                value={formData.tuesday}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Wednesday</label>

              <input
                type="text"
                name="wednesday"
                value={formData.wednesday}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Thursday</label>

              <input
                type="text"
                name="thursday"
                value={formData.thursday}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Friday</label>

              <input
                type="text"
                name="friday"
                value={formData.friday}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Saturday</label>

              <input
                type="text"
                name="saturday"
                value={formData.saturday}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Sunday</label>

              <input
                type="text"
                name="sunday"
                value={formData.sunday}
                onChange={handleChange}
              />
            </div>
          </div>

          <button className="add-plan-btn" onClick={handleUpdate}>
            Update Workout Plan
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
